import { render, staticRenderFns } from "./matching-card-placeholder.vue?vue&type=template&id=d9c5e1d2&scoped=true&"
import script from "./matching-card-placeholder.vue?vue&type=script&lang=ts&"
export * from "./matching-card-placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./matching-card-placeholder.vue?vue&type=style&index=0&id=d9c5e1d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c5e1d2",
  null
  
)

export default component.exports